var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-item',{attrs:{"label":_vm.$t('ssp_color'),"keybind":"C"},model:{value:(_vm.module.showParamsWindow),callback:function ($$v) {_vm.$set(_vm.module, "showParamsWindow", $$v)},expression:"module.showParamsWindow"}})}
var staticRenderFns = []

export { render, staticRenderFns }